/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from "react";
import {
  Button,
  Grid,
  InputAdornment,
  TextField,
  Typography,
  CircularProgress,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  FormControl,
  Modal,
  Box,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
  IconButton,
  Paper,
} from "@mui/material";
import RangeDatePicker from "../../ChurnComponent/AppDatePicker/AppDatePicker";
import DashboardFrontCard from "../../ChurnComponent/DashboardFrontCard/DashboardFrontCard";
import AppHeader from "../../../../common/Pages/AppHeader/AppHeader";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";

import {
  GraphPredictionResponse,
  PredictionsCardResponse,
  RiderCategoryStatsResponse,
  ZyppAgeStatsResponse,
} from "../../../../@Types/DRO/ChurnApiResponse/GraphPredictionResponse";
// import { PredictionGraphApi } from "../../../../API/PredictionGraph/GetPredictionGraphApi";
// import { WordCloudApi } from "../../../../API/WordCloud/GetWordCloudDataApi";
import {
  Line,
  LineChart,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Label,
} from "recharts";
import { PredictionsAllResponse, AgentproductivityAllResponse } from "../../../../@Types/DRO/ChurnApiResponse/PredictionListResponse";
// import { PredictionListApi } from "../../../../API/PredictionsList/GetPredictionsListApi";
import WordCloud from "react-wordcloud";
import { ArrowOutward, Edit } from "@mui/icons-material";
import { UserPastTicketResponse } from "../../../../@Types/DRO/ChurnApiResponse/UserPastTicketsResponse";
// import { GetUserPastTicketsApi } from "../../../../API/UserTickets/UserPastTicketsApi";
import { ChurnCallUpdateRequest } from "../../../../@Types/DTO/ChurnCallUpdateRequest/ChurnCallUpdateBody";
import { ChurnCallUpdateApi } from "../../../../API/Churn-Api/ChurnCallUpdate/ChurnCallUpdateApi";
import { GetUserPastTicketsApi } from "../../../../API/Churn-Api/UserTickets/UserPastTicketsApi";
import { PredictionListApi } from "../../../../API/Churn-Api/PredictionsList/GetPredictionsListApi";
import { WordCloudApi } from "../../../../API/Churn-Api/WordCloud/GetWordCloudDataApi";
import { PredictionGraphApi } from "../../../../API/Churn-Api/PredictionGraph/GetPredictionGraphApi";
import ExpandableText from "../../../../common/Pages/ExpandableText/ExpandableText";
import "./style.css";

const Dashboard = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState<any>();
  const [searchValInput, setSearchValInput] = useState("");

  const [predictionsData, setPredictionsData] =
    useState<PredictionsCardResponse>();
  const [callType, setCallType] = useState<string>("None");
  const [type, setType] = useState<string>("None");

  const [predictionsList, setPredictionsList] = useState<PredictionsAllResponse>();
  const [agentproductivityList, setAgentproductivityList] = useState<AgentproductivityAllResponse>();

  const [zyppAgeStats, setZyppAgeStats] = useState<ZyppAgeStatsResponse | null>(
    null
  );
  const [riderCategoryData, setRiderCategoryData] =
    useState<RiderCategoryStatsResponse | null>(null);
  const [graphData, setGraphData] = useState<GraphPredictionResponse | null>(
    null
  );
  const [wordCloudData, setWordCloudData] = useState([]);

  const [loading, setLoading] = useState<boolean>(true);

  const options = {
    fontSizes: [12, 50] as [number, number], // Ensure correct tuple
    rotations: 2,
    rotationAngles: [-90, 0] as [number, number],
    enableTooltip: true,
    deterministic: false,
    padding: 1,
    scale: "sqrt" as "linear" | "log" | "sqrt", 
    // spiral: "archimedean",
    transitionDuration: 1000,
  };
  
  
  const formatDate = (date: Date): string => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice();
    return `${year}-${month}-${day}`;
  };
  const tableHeaderCellStyle = {
    fontWeight: 600,
    fontSize: "14px",
    color: "#455A64",
    font: "Rubik",
  };
  const tableBodyCellStyle = {
    fontWeight: 400,
    fontSize: "14px",
    color: "#A4A2A2",
    font: "Rubik",
  };
  const pageRange = 5;

  const calculateRelativeDate = (days: number): Date => {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - days);
    return currentDate;
  };
  const [startDate, setStartDate] = useState<Date | null>(
    new Date(2024, 10, 1)
  );
  const [endDate, setEndDate] = useState<Date | null>(new Date(2024, 11, 30));
  const [open, setOpen] = useState(false);
  const [openReason, setOpenReason] = useState(false);
  const [selectedPredId, setSelectedPredId] = useState<number | null>(null);
  const [selectedReasons, setSelectedReasons] = useState<string[]>([]); // Explicitly typed as string[]
  const [typeOfCall, setTypeOfCall] = useState<string>("");
  const [remarks, setRemarks] = useState<string>("");
  const [openTicket, setOpenTicket] = React.useState(false);

  const filteredPredictions = predictionsList?.records.filter(
    (prediction) =>
      prediction.eb_number
        .toLowerCase()
        .includes(searchValInput.toLowerCase()) ||
      prediction.user_id.toString().includes(searchValInput)
  );
  console.log("jjjjjjjjjj--", predictionsList?.total_count);

  const [userPastTickets, setUserPastTickets] =
    useState<UserPastTicketResponse>();
  const exportTableDataToCSV = (data: any[], filename: string) => {
    if (!data || data.length === 0) return;

    const headers = Object.keys(data[0]);
    const csvRows = [];
    csvRows.push(headers.join(","));

    data.forEach((row) => {
      const values = headers.map((header) => {
        const escaped = ("" + row[header]).replace(/"/g, '\\"');
        return `"${escaped}"`;
      });
      csvRows.push(values.join(","));
    });

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleOpenTicket = async (user_id: number) => {
    try {
      const response = await GetUserPastTicketsApi.api.getUserPastTickets(
        user_id
      );
      console.log("User Past Tickets:", response);
      setOpenTicket(true);
      setUserPastTickets(response);
    } catch (error) {
      console.error("Error fetching user past tickets", error);
    }
  };
  const handleCloseTicket = () => setOpenTicket(false);

  const handleOpen = () => {
    setOpen(true);
    fetchWordCloudData(); // Fetch data when open is triggered
  };
  const handleOpenReason = (pred_id: number) => {
    setSelectedPredId(pred_id);
    setSelectedReasons([]);
    setOpenReason(true);
  };
  const handleClose = () => setOpen(false);
  useEffect(() => {
    const fetchZyppAgeStats = async () => {
      if (startDate && endDate) {
        try {
          const formattedStartDate = formatDate(startDate);
          const formattedEndDate = formatDate(endDate);
          const data = await PredictionGraphApi.api.getZyppAgeStats(
            formattedStartDate,
            formattedEndDate
          );
          setZyppAgeStats(data);
        } catch (error) {
          console.error("Error fetching Zypp Age Stats", error);
        }
      }
    };

    fetchZyppAgeStats();
  }, [startDate, endDate]);

  useEffect(() => {
    const fetchRiderCategoryData = async () => {
      if (startDate && endDate) {
        try {
          const formattedStartDate = formatDate(startDate);
          const formattedEndDate = formatDate(endDate);
          const data = await PredictionGraphApi.api.getRiderCategoryStats(
            formattedStartDate,
            formattedEndDate
          );
          setRiderCategoryData(data);
        } catch (error) {
          console.error("Error fetching Zypp Age Stats", error);
        }
      }
    };

    fetchRiderCategoryData();
  }, [startDate, endDate]);

  const handleDateChange = (dates: [Date | null, Date | null]) => {
    setStartDate(dates[0]);
    setEndDate(dates[1]);
    fetchPredictionsData(dates[0], dates[1], callType, type, page + 1);
  };
  const handleCallTypeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedCallType = event.target.value;
    setCallType(selectedCallType || "None");
    fetchPredictionsData(startDate, endDate, selectedCallType, type, page + 1);
  };

  const handleTypeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedType = event.target.value;
    setType(selectedType || "None");
    fetchPredictionsData(startDate, endDate, callType, selectedType, page + 1);
  };
  const fetchPredictionsData = async (
    start: Date | null,
    end: Date | null,
    callType: string,
    type: string,
    page: number,
    find: string = "None",
    export_data: boolean = false
  ) => {
    if (start && end) {
      setLoading(true);
      try {
        const formattedStartDate = formatDate(start);
        const formattedEndDate = formatDate(end);
        const response = await PredictionListApi.api.getPredictionsAll(
          formattedStartDate,
          formattedEndDate,
          callType,
          type,
          page + 1,
          find,
          export_data ? true : false
        );
        setPredictionsList(response);
        setTotalCount(response.total_count);
        console.log("Fetched predictions list:", response);
      } catch (error) {
        console.error("Error fetching predictions data", error);
      } finally {
        setLoading(false);
      }
    }
  };
  const fetchAgentproductivityData = async (
    start: Date | null,
    end: Date | null,
  ) => {
    if (start && end) {
      setLoading(true);
      try {
        const formattedStartDate = formatDate(start);
        const formattedEndDate = formatDate(end);
        const response = await PredictionListApi.api.getAgentproductivityAll(
          formattedStartDate,
          formattedEndDate,
        );
        setAgentproductivityList(response);
        console.log("Fetched predictions list:", response);
      } catch (error) {
        console.error("Error fetching predictions data", error);
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    fetchAgentproductivityData(startDate, endDate);
  }, [startDate, endDate]);
  // Update the useEffect to call fetchPredictionsData with exportData as false
  useEffect(() => {
    fetchPredictionsData(startDate, endDate, callType, type, page, searchValInput, false);
  }, [startDate, endDate, callType, type, page]);

  useEffect(() => {
    fetchPredictionsData(startDate, endDate, callType, type, page);
  }, [startDate, endDate, callType, type, page]);

  const pageCount = Math.ceil(totalCount / rowsPerPage);
  const handlePageChange = (newPage: number) => {
    const newPageNumber = Math.max(0, Math.min(newPage, pageCount - 1));
    setPage(newPageNumber);
    fetchPredictionsData(startDate, endDate, callType, type, newPageNumber, searchValInput);
  };

  const renderPageNumbers = () => {
    const pagesToShow = Math.min(pageCount, 5); // Show up to 5 page numbers
    const startPage = Math.max(
      0,
      Math.min(page - Math.floor(5 / 2), pageCount - pagesToShow)
    );

    return Array.from({ length: pagesToShow }, (_, index) => {
      const pageNumber = startPage + index;
      return (
        <span
          key={index}
          onClick={() => handlePageChange(pageNumber)}
          className={page === pageNumber ? "active" : "unactive"}
          style={{ marginLeft: "6px" }}>
          {pageNumber + 1}
        </span>
      );
    });
  };
  const handleClearSearch = () => {
    setSearchValInput("");
    fetchPredictionsData(startDate, endDate, callType, type, page, searchValInput, false);
  };

  useEffect(() => {
    const fetchPredictionsCards = async () => {
      if (startDate && endDate) {
        setLoading(true);
        try {
          const formattedStartDate = formatDate(startDate);
          const formattedEndDate = formatDate(endDate);
          const data = await PredictionGraphApi.api.getPredictionsCards(
            formattedStartDate,
            formattedEndDate
          );
          console.log("Fetched data:", data);
          setPredictionsData(data);
        } catch (error) {
          console.error("Error fetching predictions cards data", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchPredictionsCards();
  }, [startDate, endDate]);

  useEffect(() => {
    const fetchChurnPercentGraph = async () => {
      setLoading(true);
      try {
        const data = await PredictionGraphApi.api.getChurnPercentGraph();
        setGraphData(data);
      } catch (error) {
        console.error("Error fetching churn percent graph data", error);
      } finally {
        setLoading(false);
      }
    };

    fetchChurnPercentGraph();
  }, []);

  const fetchWordCloudData = async () => {
    setLoading(true);
    try {
      const response = await WordCloudApi.api.getWordCloudData(); // Fetch raw data from API
      const rawData = response; // Assuming 'data' contains the relevant records

      // Map rawData to word cloud data format
      const wordCloudData = rawData.records.map((word: any) => ({ 
        text: word,
        value: Math.floor(Math.random() * 100) + 1, // Assign a random value for word frequency
      }));

      setWordCloudData(wordCloudData); // Update state with processed word cloud data
    } catch (error) {
      console.error("Error fetching word cloud data", error);
    } finally {
      setLoading(false);
    }
  };
  const reasons = [
    "Wallet Issue",
    "TL/Management Issue",
    "Payout Issue",
    "Penalty Issue",
    "Client Issue",
    "Vehicle Issue",
    "Not Working Past 10 Days",
    "Insurance Issue",
    "App Issue",
    "Ride End Issue",
  ];

  const handleCheckboxChange = (reason: string): void => {
    setSelectedReasons((prev) =>
      prev.includes(reason)
        ? prev.filter((item) => item !== reason)
        : [...prev, reason]
    );
  };
  const handleSubmitReason = async () => {
    if (selectedPredId) {
      const data: ChurnCallUpdateRequest = {
        type_of_call: typeOfCall,
        remarks: remarks,
        wallet_issue: selectedReasons.includes("Wallet Issue"),
        vehicle_issue: selectedReasons.includes("Vehicle Issue"),
        tl_management_issue: selectedReasons.includes("TL/Management Issue"),
        not_working_10_days: selectedReasons.includes(
          "Not Working Past 10 Days"
        ),
        payout_issue: selectedReasons.includes("Payout Issue"),
        insurance_issue: selectedReasons.includes("Insurance Issue"),
        penalty_issue: selectedReasons.includes("Penalty Issue"),
        app_issue: selectedReasons.includes("App Issue"),
        client_issue: selectedReasons.includes("Client Issue"),
        ride_end_issue: selectedReasons.includes("Ride End Issue"),
      };

      try {
        const response = await ChurnCallUpdateApi.api.updateChurnCall(
          selectedPredId,
          data
        );
        console.log("Churn call updated successfully:", response);
        setOpenReason(false);
        setTypeOfCall("");
        setRemarks("");
        setSelectedReasons([]);
        fetchPredictionsData(startDate, endDate, callType, type, page);
      } catch (error) {
        console.error("Error updating churn call:", error);
      }
    }
  };
  return (
    <>
      <AppHeader />
      <div className="bg-[#D8FFEA] px-8  pt-8 pb-16 w-full">
        <div className="flex items-center ">
          <RangeDatePicker
            onChange={handleDateChange}
            maxDaysAdd={-2}
            minDaysSub={183}
            defaultStartDate={startDate || new Date()}
            defaultEndDate={endDate || new Date()}
          />
        </div>
      </div>
      <div className="bg-[#f2f2f2] w-full">
        <div className="flex ">
          {predictionsData?.records.map((record, index) => (
            <>
              <DashboardFrontCard
                key={index}
                textFirstLine="Prediction Count"
                clientData={
                  loading ? (
                    <CircularProgress size={20} />
                  ) : (
                    record.predictions_count
                  )
                } // Show loader if loading
                imageURL="/assets/user-green.svg"
                lineImageURL="/assets/green-line.svg"
              />
              <DashboardFrontCard
                key={index}
                textFirstLine="Rider Left"
                clientData={
                  loading ? <CircularProgress size={20} /> : record.left_count
                } // Show loader if loading
                imageURL="/assets/user-red.svg"
                lineImageURL="/assets/red-line.svg"
              />
              <DashboardFrontCard
                key={index}
                textFirstLine="Rider Retained"
                clientData={
                  loading ? (
                    <CircularProgress size={20} />
                  ) : (
                    record.retained_count
                  )
                } // Show loader if loading
                imageURL="/assets/user-blue.svg"
                lineImageURL="/assets/blue-line.svg"
              />
            </>
          ))}
        </div>
        <div className="flex mx-6">
          <div className="w-full  bg-white min-h-80 shadow-lg p-3 rounded-xl">
            <div className="flex  items-center border-b">
              <h2 className="text-center ml-4 mx-1 mt-2 pb-2 font-bold text-base text-black">
                Churn Prediction %
              </h2>
            </div>
            <div className="py-1 pb-4 flex w-full">
              <div style={{ width: "100%", height: 300 }}>
                {loading ? (
                  <div className="flex justify-center items-center h-full">
                    <CircularProgress size={50} />{" "}
                    {/* Show loader if loading */}
                  </div>
                ) : (
                  <LineChart
                    width={1100}
                    height={300}
                    data={
                      graphData
                        ? graphData.records.months.map(
                            (month: string, index: number) => ({
                              Month: month,
                              ChurnRate: parseFloat(
                                graphData.records.churn_rates[index].toFixed(2)
                              ),
                              AllotmentsGrowth: parseFloat(
                                graphData.records.allotments_growth_rates[
                                  index
                                ].toFixed(2)
                              ),
                              RetentionGrowth: parseFloat(
                                graphData.records.retention_growth_rates[
                                  index
                                ].toFixed(2)
                              ),
                            })
                          )
                        : []
                    }>
                    <CartesianGrid vertical={false} horizontal={false} />
                    <XAxis dataKey="Month" tick={{ fontSize: 10 }}>
                      <Label value="Month ->" fontSize={11} dy={16} />
                    </XAxis>
                    <YAxis tick={{ fontSize: 10 }} />
                    <Tooltip />
                    <Line
                      type="monotone"
                      dataKey="ChurnRate"
                      dot={false}
                      stroke="#FF0000"
                    />
                    <Line
                      type="monotone"
                      dataKey="AllotmentsGrowth"
                      dot={false}
                      stroke="#00FF00"
                    />
                    <Line
                      type="monotone"
                      dataKey="RetentionGrowth"
                      dot={false}
                      stroke="#0000FF"
                    />
                  </LineChart>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="flex mx-6 my-10">
          <div className="w-full flex justify-center">
            <div className="flex items-center  bg-white border border-[#ECEEFF]	border-solid rounded-full px-2 py-1 mr-3">
              <div>
                <Typography className="font-inter text-[#727597] text-xs mr-2 font-normal">
                  Call Type:{" "}
                </Typography>
              </div>
              <FormControl>
                <select
                  id="merchant"
                  value={callType}
                  onChange={handleCallTypeChange}>
                  <option value="None">None</option>
                  <option value="CALL_BACK_REQUIRED">Call Back Required</option>
                  <option value="UNINTERESTED_TO_ANSWER">
                    Uninterested to answer
                  </option>
                  <option value="HOLIDAYS_NOT_WELL">Holidays Not Well</option>
                  <option value="FOLLOW_UP">Follow Up</option>
                  <option value="LANGUAGE_BARRIER">Language Barrier</option>
                  <option value="VEHICLE_SUBMIT">Vehicle Submit</option>
                  <option value="RETAINED">Retained</option>
                  <option value="CALL_CONNECTED">Call Connected</option>
                </select>
              </FormControl>
            </div>
            <div className="flex items-center  bg-white border border-[#ECEEFF]	border-solid rounded-full px-2 py-1 mr-3">
              <div>
                <Typography className="font-inter text-[#727597] text-xs mr-2 font-normal">
                  Type:{" "}
                </Typography>
              </div>
              <FormControl>
                <select id="merchant" value={type} onChange={handleTypeChange}>
                  <option value="None">None</option>
                  <option value="RIDER_LEFT">Rider Left</option>
                  <option value="RIDER_NOT_LEFT">Rider Not Left</option>
                  <option value="RIDER_RETAINED">Rider Retained</option>
                </select>
              </FormControl>
            </div>
            <div className="flex items-center ">
              <RangeDatePicker
                onChange={handleDateChange}
                maxDaysAdd={-2}
                minDaysSub={183}
                defaultStartDate={startDate || new Date()}
                defaultEndDate={endDate || new Date()}
              />
            </div>
          </div>
        </div>

        <div className="flex mx-6 mt-6">
          <div className="w-full flex bg-white min-h-80 shadow-lg p-3 rounded-xl">
            <div className="w-full">
              <Grid
                container
                spacing={5}
                className="w-full flex justify-between ">
                <Grid item md={4}>
                  <div className="flex ml-4">
                    <h2 className="text-center ml-2 mx-1 mt-2 font-bold text-base text-black pb-2">
                      ALL USER DETAILS
                    </h2>
                  </div>
                </Grid>
                <Grid item md={8}>
                  <div className="flex mr-4">
                    <div className="flex w-full justify-end">
                      <div className="mr-3">
                        <TextField
                          placeholder="EB Number, UserId"
                          id="outlined-basic"
                          variant="outlined"
                          onChange={(search: any) => {
                            setSearchValInput(search.target.value);
                            fetchPredictionsData(
                              startDate,
                              endDate,
                              callType,
                              type,
                              page,
                              search.target.value,
                              false
                            ); 
                          }}
                          value={searchValInput}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <SearchIcon />
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <InputAdornment
                                position="end"
                                onClick={handleClearSearch}>
                                <ClearIcon style={{ cursor: "pointer" }} />
                              </InputAdornment>
                            ),
                            style: { height: "40px", borderRadius: "25px" },
                          }}
                        />
                      </div>
                      <div>
                        <Button
                          style={{
                            backgroundColor: "#06B681",
                            padding: "8px 20px",
                            color: "#fff",
                            borderRadius: "25px",
                            width: "100%",
                            textTransform: "none",
                          }}
                          onClick={handleOpen}>
                          Word Cloud
                        </Button>
                      </div>
                      <div>
                        <Button
                          style={{
                            backgroundColor: "#06B681",
                            padding: "8px 20px",
                            color: "#fff",
                            borderRadius: "25px",
                            width: "100%",
                            textTransform: "none",
                            marginLeft: "10px",
                          }}
                          onClick={() =>
                            exportTableDataToCSV(
                              predictionsList?.records || [],
                              "predictions.csv"
                            )
                          }>
                          Export
                        </Button>
                      </div>
                    </div>
                  </div>
                </Grid>
              </Grid>

              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 100 }}>
                        Date
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 100 }}>
                        User Id
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 150 }}>
                        Rider Name
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 150 }}>
                        Agent Name
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 150 }}>
                        Eb Number
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 100 }}>
                        Prob_Active
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 100 }}>
                        Prob_Left
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 100 }}>
                        Prob_Retained
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 150 }}>
                        Wallet Balance
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 150 }}>
                        TL Name
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 100 }}>
                        City
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 150 }}>
                        Fleet Type
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 150 }}>
                        Fleet Age
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 150 }}>
                        Merchant Name
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 150 }}>
                        Hub Name
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 150 }}>
                        Tickets Raised
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 100 }}>
                        Incentives
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 150 }}>
                        7 Days Earning
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 150 }}>
                        Validation Status
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 250 }}>
                        Remarks
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 100 }}>
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {predictionsList?.records.map((prediction, index) => (
                      <TableRow key={index}>
                        <TableCell style={tableBodyCellStyle}>
                          {prediction.prediction_date}
                        </TableCell>
                        <TableCell style={tableBodyCellStyle}>
                          {prediction.user_id}
                        </TableCell>
                        <TableCell style={tableBodyCellStyle}>
                          {prediction.rider_name}
                        </TableCell>
                        <TableCell style={tableBodyCellStyle}>
                          {prediction.agent_name}
                        </TableCell>
                        <TableCell style={tableBodyCellStyle}>
                          {prediction.eb_number}
                        </TableCell>
                        <TableCell style={tableBodyCellStyle}>
                          {prediction.prob_active}
                        </TableCell>
                        <TableCell style={tableBodyCellStyle}>
                          {prediction.prob_left}
                        </TableCell>
                        <TableCell style={tableBodyCellStyle}>
                          {prediction.prob_retained}
                        </TableCell>
                        <TableCell style={tableBodyCellStyle}>
                          {prediction.wallet_balance}
                        </TableCell>
                        <TableCell style={tableBodyCellStyle}>
                          {prediction.tl_name}
                        </TableCell>
                        <TableCell style={tableBodyCellStyle}>
                          {prediction.user_city}
                        </TableCell>
                        <TableCell style={tableBodyCellStyle}>
                          {prediction.fleet_type}
                        </TableCell>
                        <TableCell style={tableBodyCellStyle}>
                          {prediction.fleet_age}
                        </TableCell>
                        <TableCell style={tableBodyCellStyle}>
                          {prediction.merchant_name}
                        </TableCell>
                        <TableCell style={tableBodyCellStyle}>
                          {prediction.hub_name}
                        </TableCell>

                        <TableCell style={tableBodyCellStyle}>
                          <IconButton
                            onClick={() => handleOpenTicket(prediction.user_id)}
                            sx={{ color: "#06b681", marginLeft: 1 }}>
                            <ArrowOutward fontSize="small" />
                          </IconButton>
                        </TableCell>
                        <TableCell style={tableBodyCellStyle}>
                          {prediction.incentive}
                        </TableCell>
                        <TableCell style={tableBodyCellStyle}>
                          {prediction.last_seven_days_earning}
                        </TableCell>
                        <TableCell style={tableBodyCellStyle}>
                          {prediction.validation_status}
                        </TableCell>
                        <TableCell style={tableBodyCellStyle}>
                          <ExpandableText
                            text={prediction.remarks || "-"}
                            wordLimit={10}
                          />
                        </TableCell>
                        <TableCell style={tableBodyCellStyle}>
                          <IconButton
                            onClick={() =>
                              handleOpenReason(prediction.pred_id)
                            }>
                            <Edit sx={{ color: "#06b681" }} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <div className="pl-2 pt-4 pb-2 pr-16">
                <div
                  className="pagination"
                  style={{ display: "flex", justifyContent: "space-between" }}>
                  <div>
                    <button
                      onClick={() => handlePageChange(page - 1)}
                      disabled={page === 0}
                      style={{
                        fontFamily: "Rubik",
                        fontSize: "20px",
                        marginRight: "6px",
                      }}>
                      {"<"}
                    </button>
                    {renderPageNumbers()}
                    <button
                      onClick={() => handlePageChange(page + 1)}
                      disabled={page >= pageCount - 1}
                      style={{
                        fontFamily: "Rubik",
                        fontSize: "20px",
                        marginLeft: "6px",
                      }}>
                      {">"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex mx-6 mt-6">
          <div className="w-full flex bg-white min-h-60 shadow-lg p-3 rounded-xl">
            <div className="w-full">
              <Grid
                container
                spacing={5}
                className="w-full flex justify-between ">
                <Grid item md={4}>
                  <div className="flex ml-4">
                    <h2 className="text-center ml-2 mx-1 mt-2 font-bold text-base text-black pb-2">
                    Agent Productivity
                    </h2>
                  </div>
                </Grid>
                
              </Grid>

              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 100 }}>
                        Agent Id
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 100 }}>
                        Agent Name
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 150 }}>
                        Total Calls
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 150 }}>
                        Not Connected Count
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 150 }}>
                        Connected Count
                      </TableCell>
                      <TableCell
                        style={tableHeaderCellStyle}
                        sx={{ minWidth: 100 }}>
                        Retained Count
                      </TableCell>
                      
                     
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {agentproductivityList?.records.map((prediction, index) => (
                      <TableRow key={index}>
                        <TableCell style={tableBodyCellStyle}>
                          {prediction.agent_id}
                        </TableCell>
                        <TableCell style={tableBodyCellStyle}>
                          {prediction.agent_name}
                        </TableCell>
                        <TableCell style={tableBodyCellStyle}>
                          {prediction.total_calls}
                        </TableCell>
                        <TableCell style={tableBodyCellStyle}>
                          {prediction.not_connected_count}
                        </TableCell>
                        <TableCell style={tableBodyCellStyle}>
                          {prediction.connected_count}
                        </TableCell>
                        <TableCell style={tableBodyCellStyle}>
                          {prediction.retained_count}
                        </TableCell>
                        

                        
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              
            </div>
          </div>
        </div>
        <div className="flex mx-6 mt-6 pb-10">
          <Grid container spacing={5} className="w-full flex justify-between ">
            <Grid item md={6}>
              <div className="w-full flex bg-white min-h-80 shadow-lg p-3 rounded-xl">
                <div className="w-full">
                  <Grid
                    container
                    spacing={5}
                    className="w-full flex justify-between ">
                    <Grid item md={6}>
                      <div className="flex ml-4">
                        <h2 className="text-center  mx-1 mt-2 font-bold text-base text-black pb-2">
                          ZYPP AGE RANGE ANALYSIS
                        </h2>
                      </div>
                    </Grid>
                    <Grid item md={6}>
                      <div className="flex mr-4">
                        <div className="flex w-full justify-end">
                          <div>
                            <Button
                              style={{
                                backgroundColor: "#06B681",
                                padding: "8px 20px",
                                color: "#fff",
                                borderRadius: "25px",
                                width: "100%",
                                textTransform: "none",
                                marginLeft: "10px",
                              }}
                              onClick={() =>
                                exportTableDataToCSV(
                                  zyppAgeStats?.records || [],
                                  "zypp_age_stats.csv"
                                )
                              }>
                              Export
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                  <hr className="mt-4" />
                  <TableContainer style={{ minHeight: "300px" }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            style={tableHeaderCellStyle}
                            sx={{
                              minWidth: 100,
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                            }}>
                            Zypp Age Range
                          </TableCell>
                          <TableCell
                            style={tableHeaderCellStyle}
                            sx={{
                              minWidth: 100,
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                            }}>
                            Riders Left
                          </TableCell>
                          <TableCell
                            style={tableHeaderCellStyle}
                            sx={{
                              minWidth: 100,
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                            }}>
                            Rider Retained
                          </TableCell>
                          <TableCell
                            style={tableHeaderCellStyle}
                            sx={{
                              minWidth: 100,
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                            }}>
                            Ratio
                          </TableCell>
                          <TableCell
                            style={tableHeaderCellStyle}
                            sx={{
                              minWidth: 100,
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                            }}>
                            Churn Percent
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {zyppAgeStats?.records?.map((stat, index) => (
                          <TableRow key={index}>
                            <TableCell
                              style={tableBodyCellStyle}
                              sx={{
                                minWidth: 100,
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                              }}>
                              {stat.zypp_age_bucket}
                            </TableCell>
                            <TableCell
                              style={tableBodyCellStyle}
                              sx={{
                                minWidth: 100,
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                              }}>
                              {stat.number_left}
                            </TableCell>
                            <TableCell
                              style={tableBodyCellStyle}
                              sx={{
                                minWidth: 100,
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                              }}>
                              {stat.number_retained}
                            </TableCell>
                            <TableCell
                              style={tableBodyCellStyle}
                              sx={{
                                minWidth: 100,
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                              }}>
                              {stat.left_to_retained_ratio.toFixed(2)}
                            </TableCell>
                            <TableCell
                              style={tableBodyCellStyle}
                              sx={{
                                minWidth: 100,
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                              }}>
                              {stat.churn_percentage.toFixed(2)}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* <div className="pl-2 pt-4 pb-2 pr-16">
                    <div
                      className="pagination"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}>
                      <div>
                        <button
                          onClick={() => handlePageChange(page - 1)}
                          disabled={page === 0}
                          style={{
                            fontFamily: "Rubik",
                            fontSize: "20px",
                            marginRight: "6px",
                          }}>
                          {"<"}
                        </button>
                        {renderPageNumbers()}
                        <button
                          onClick={() => handlePageChange(page + 1)}
                          disabled={page >= pageCount - 1}
                          style={{
                            fontFamily: "Rubik",
                            fontSize: "20px",
                            marginLeft: "6px",
                          }}>
                          {">"}
                        </button>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </Grid>
            <Grid item md={6}>
              <div
                className="w-full flex bg-white min-h-80 shadow-lg p-3 rounded-xl"
                style={{ minHeight: "400px" }}>
                <div className="w-full">
                  <Grid
                    container
                    spacing={5}
                    className="w-full flex justify-between ">
                    <Grid item md={6}>
                      <div className="flex ml-4">
                        <h2 className="text-center  mx-1 mt-2 font-bold text-base text-black pb-2">
                          Rider Category Stats
                        </h2>
                      </div>
                    </Grid>
                    <Grid item md={6}>
                      <div className="flex mr-4">
                        <div className="flex w-full justify-end">
                          <div>
                            <Button
                              style={{
                                backgroundColor: "#06B681",
                                padding: "8px 20px",
                                color: "#fff",
                                borderRadius: "25px",
                                width: "100%",
                                textTransform: "none",
                                marginLeft: "10px",
                              }}
                              onClick={() =>
                                exportTableDataToCSV(
                                  riderCategoryData?.records || [],
                                  "rider_category_stats.csv"
                                )
                              }>
                              Export
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                  <hr className="mt-4" />

                  <TableContainer style={{ minHeight: "300px" }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            style={tableHeaderCellStyle}
                            sx={{
                              minWidth: 100,
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                            }}>
                            Rider Category
                          </TableCell>
                          <TableCell
                            style={tableHeaderCellStyle}
                            sx={{
                              minWidth: 100,
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                            }}>
                            Riders Left
                          </TableCell>
                          <TableCell
                            style={tableHeaderCellStyle}
                            sx={{
                              minWidth: 100,
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                            }}>
                            Rider Retained
                          </TableCell>
                          <TableCell
                            style={tableHeaderCellStyle}
                            sx={{
                              minWidth: 100,
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                            }}>
                            Ratio
                          </TableCell>
                          <TableCell
                            style={tableHeaderCellStyle}
                            sx={{
                              minWidth: 100,
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                            }}>
                            Churn Percent
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {riderCategoryData?.records?.map((stat, index) => (
                          <TableRow key={index}>
                            <TableCell
                              style={tableBodyCellStyle}
                              sx={{
                                minWidth: 100,
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                              }}>
                              {stat.category_bucket}
                            </TableCell>
                            <TableCell
                              style={tableBodyCellStyle}
                              sx={{
                                minWidth: 100,
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                              }}>
                              {stat.number_left}
                            </TableCell>
                            <TableCell
                              style={tableBodyCellStyle}
                              sx={{
                                minWidth: 100,
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                              }}>
                              {stat.number_retained}
                            </TableCell>
                            <TableCell
                              style={tableBodyCellStyle}
                              sx={{
                                minWidth: 100,
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                              }}>
                              {stat.left_to_retained_ratio.toFixed(2)}
                            </TableCell>
                            <TableCell
                              style={tableBodyCellStyle}
                              sx={{
                                minWidth: 100,
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                              }}>
                              {stat.churn_percentage.toFixed(2)}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <div className="pl-2 pt-4 pb-2 pr-16">
                    <div
                      className="pagination"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}></div>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="word-cloud-modal-title"
          aria-describedby="word-cloud-modal-description">
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "80%",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
              outline: "none",
            }}>
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => setOpen(false)}
              aria-label="close"
              sx={{
                position: "absolute",
                top: 7,
                right: 14,
                color: "#000",
              }}>
              <CloseIcon />
            </IconButton>
            <h2 id="word-cloud-modal-title">WORD CLOUD</h2>
            <div id="word-cloud-modal-description" style={{ height: "400px" }}>
              {wordCloudData.length > 0 ? (
                <WordCloud words={wordCloudData} options={options} />
              ) : (
                <p>Loading word cloud data...</p>
              )}
            </div>
          </Box>
        </Modal>

        <Modal open={openReason} onClose={() => setOpenReason(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "40%",
              maxHeight: "90%", // Ensure the modal height does not exceed the screen

              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              p: 3,
              overflowY: "auto", // Enable vertical scrolling
            }}>
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => setOpenReason(false)}
              aria-label="close"
              sx={{
                position: "absolute",
                top: 7,
                right: 14,
                color: "#000",
              }}>
              <CloseIcon />
            </IconButton>
            <Typography variant="h6">CHURN REASON</Typography>
            <Typography variant="body2" sx={{ color: "#06B681", mb: 2 }}>
              Last Updated By
            </Typography>
            <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
              {reasons.map((reason) => (
                <FormControlLabel
                  key={reason}
                  control={
                    <Checkbox
                      checked={selectedReasons.includes(reason)}
                      onChange={() => handleCheckboxChange(reason)}
                      sx={{
                        //color: '#06B681',
                        padding: "5px", // Default color
                        "&.Mui-checked": {
                          color: "#06B681", // Custom color when checked
                        },
                      }}
                    />
                  }
                  label={
                    <Typography sx={{ fontSize: "12px" }}>{reason}</Typography>
                  }
                />
              ))}
            </Box>
            <Typography variant="body2" sx={{ mt: 2, mb: 1 }}>
              Type Of Call
            </Typography>
            <Select
              fullWidth
              value={typeOfCall}
              onChange={(e) => setTypeOfCall(e.target.value)}
              sx={{ height: "40px" }}>
              <MenuItem value="CALL_BACK_REQUIRED">CALL_BACK_REQUIRED</MenuItem>
              <MenuItem value="UNINTERESTED_TO_ANSWER">
                UNINTERESTED_TO_ANSWER
              </MenuItem>
              <MenuItem value="HOLIDAYS_NOT_WELL">HOLIDAYS_NOT_WELL</MenuItem>
              <MenuItem value="FOLLOW_UP">FOLLOW_UP</MenuItem>
              <MenuItem value="LANGUAGE_BARRIER">LANGUAGE_BARRIER</MenuItem>
            </Select>
            <Typography variant="body2" sx={{ mt: 2, mb: 1 }}>
              Remarks
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={3}
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              placeholder="Up to 300 Word Range"
            />
            <Button
              variant="contained"
              color="primary"
              fullWidth
              style={{
                backgroundColor: "#000",
                padding: "8px 20px",
                color: "#fff",
                width: "100%",
                textTransform: "none",
                marginTop: "10px",
              }}
              onClick={handleSubmitReason}>
              Submit
            </Button>
          </Box>
        </Modal>

        <Modal open={openTicket} onClose={handleCloseTicket}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "80%",
              maxHeight: "80%", // Ensure the modal height does not exceed the screen

              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              p: 3,
              overflowY: "auto", // Enable vertical scrolling
            }}>
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => setOpenTicket(false)}
              aria-label="close"
              sx={{
                position: "absolute",
                top: 7,
                right: 14,
                color: "#000",
              }}>
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
              Tickets Raised
            </Typography>
            <Grid container spacing={2}>
              {userPastTickets?.records.map((ticket, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Paper elevation={3}>
                    <div
                      style={{
                        backgroundColor:
                          ticket.ticket_status === "Closed" ? "green" : "red",
                        color: "#fff",
                      }}
                      className="rounded-t-md">
                      <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        className="pl-2 ">
                        Ticket ID - {ticket.user_id}
                      </Typography>
                    </div>
                    <div className="p-2">
                      <Typography>
                        Ticket Type - {ticket.ticket_type}
                      </Typography>
                      <Typography>
                        Type of Ticket- {ticket.type_of_ticket}
                      </Typography>
                      <Typography>
                        Price Penalty - {ticket.total_penalty}
                      </Typography>
                      <Typography>Remarks - {ticket.qr_code}</Typography>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          mt: 1,
                          color:
                            ticket.ticket_status === "Closed" ? "green" : "red",
                        }}>
                        {ticket.ticket_status}
                      </Typography>
                    </div>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default Dashboard;
